// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as BrightnessComponent} from './Brightness.svg';

import Icon, { TIconProps } from '../Icon';

export const IconBrightness = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <BrightnessComponent/>
  </Icon>
));
